import { GenericoEnum } from './generico.enum';

export enum valorTipoReunioesEnum {
    CONSELHODELIBERATIVO = 1,
    DIRETORIA = 2,
    COMITEINVGESTAO = 3,
    CONCELHOFISCAL = 4
}

export class TipoReunioesEnum {

    public static values = [
        { label: 'Selecione uma opção', value: null },
        { label: 'CONSELHODELIBERATIVO', value: valorTipoReunioesEnum.CONSELHODELIBERATIVO },
        { label: 'DIRETORIA', value: valorTipoReunioesEnum.DIRETORIA },
        { label: 'COMITEINVGESTAO', value: valorTipoReunioesEnum.COMITEINVGESTAO },
        { label: 'CONCELHOFISCAL', value: valorTipoReunioesEnum.CONCELHOFISCAL },
    ]


    public static getId(label: string): number {
        let id = null;
        this.values.forEach(element => { if (label === element.label) { id = element.value } });
        return id;
    }

    public static getObjByValues(value: any) {
        return GenericoEnum.getObjByValues(value, TipoReunioesEnum.values);
    }

    public static getDescricaoCompleta = (id: any) => {
        return GenericoEnum.getDescricaoCompleta(id, TipoReunioesEnum.values);
    };

    public static getValue = (id: boolean) => {
        return GenericoEnum.getValue(id, TipoReunioesEnum.values);
    }
}








// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/tipo-reunioes.enum.ts